document.addEventListener('DOMContentLoaded', () => {
  // Disclosure toggles
  document.querySelectorAll('[data-disclosure-toggle]').forEach(t => {
    t.addEventListener('click', () => {
      const target = document.getElementById(t.getAttribute('aria-controls'));
      const expanded = t.getAttribute('aria-expanded') === 'true';
      t.setAttribute('aria-expanded', String(!expanded));
      if (target) target.classList.toggle('hide');
    });
  });
  // Smooth anchors
  document.querySelectorAll('a[href^="#"]').forEach(a => {
    a.addEventListener('click', (e) => {
      const id = a.getAttribute('href').slice(1);
      const el = document.getElementById(id);
      if (el) { e.preventDefault(); el.scrollIntoView({behavior:'smooth', block:'start'}); }
    });
  });

  document.querySelectorAll('[data-nv-tabs]').forEach(section => {
    const tabs = Array.from(section.querySelectorAll('[data-tab-target]'));
    const panels = Array.from(section.querySelectorAll('[data-tab-panel]'));
    if (!tabs.length || !panels.length) return;

    const activate = (tabKey) => {
      tabs.forEach(tab => {
        const isActive = tab.getAttribute('data-tab-target') === tabKey;
        tab.classList.toggle('is-active', isActive);
        tab.setAttribute('aria-selected', String(isActive));
        tab.setAttribute('tabindex', isActive ? '0' : '-1');
      });

      panels.forEach(panel => {
        panel.hidden = panel.getAttribute('data-tab-panel') !== tabKey;
      });
    };

    tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => activate(tab.getAttribute('data-tab-target')));
      tab.addEventListener('keydown', (event) => {
        if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft') return;
        event.preventDefault();
        const direction = event.key === 'ArrowRight' ? 1 : -1;
        const nextIndex = (index + direction + tabs.length) % tabs.length;
        tabs[nextIndex].focus();
        activate(tabs[nextIndex].getAttribute('data-tab-target'));
      });
    });

    activate(section.getAttribute('data-nv-tabs-default') || tabs[0].getAttribute('data-tab-target'));
  });
});
